export const SUPPORT_TAB_KEYS = [
  "tickets",
  "performance",
  "teams",
  "csr_outreach",
  "chat_support_log",
  "agent_reports",
];

export const TAB_PERM_LABELS = [
  { key: "tickets", label: "Support Center (tickets)" },
  { key: "performance", label: "Performance" },
  { key: "teams", label: "Support Teams" },
  { key: "csr_outreach", label: "CSR Outreach" },
  { key: "chat_support_log", label: "Chat Support Log" },
  { key: "agent_reports", label: "Agent Reports" },
];

export const DEFAULT_LEAD_PERMS = {
  tickets: true,
  performance: true,
  teams: true,
  csr_outreach: true,
  chat_support_log: true,
  agent_reports: true,
};

export const DEFAULT_MEMBER_PERMS = {
  tickets: true,
  performance: false,
  teams: false,
  csr_outreach: true,
  chat_support_log: false,
  agent_reports: true,
};

export const DEFAULT_CHAT_SUPPORT_PERMS = {
  tickets: true,
  performance: false,
  teams: false,
  csr_outreach: false,
  chat_support_log: true,
  agent_reports: true,
};

export function defaultsForPanelRole(panelRole) {
  if (panelRole === "CSR Team Lead") return { ...DEFAULT_LEAD_PERMS };
  if (panelRole === "Chat Support") return { ...DEFAULT_CHAT_SUPPORT_PERMS };
  if (panelRole === "CSR") return { ...DEFAULT_MEMBER_PERMS };
  return {
    tickets: false,
    performance: false,
    teams: false,
    csr_outreach: false,
    chat_support_log: false,
    agent_reports: false,
  };
}

export function tabLabelsForPanelRole(panelRole) {
  if (panelRole === "Chat Support") {
    return TAB_PERM_LABELS.filter((t) =>
      ["tickets", "performance", "chat_support_log", "agent_reports"].includes(t.key)
    );
  }
  return TAB_PERM_LABELS;
}

export function storeSupportTabPermissions(perms) {
  try {
    if (perms && typeof perms === "object") {
      if ("tabPermissions" in perms || "hasTeam" in perms) {
        storeSupportAccessMeta(perms);
        return;
      }
      localStorage.setItem("supportTabPermissions", JSON.stringify(perms));
    }
  } catch {
    /* ignore */
  }
}

export function storeSupportAccessMeta(access) {
  try {
    if (access?.tabPermissions) {
      localStorage.setItem("supportTabPermissions", JSON.stringify(access.tabPermissions));
    }
    if (typeof access?.hasTeam === "boolean") {
      localStorage.setItem("supportHasTeam", access.hasTeam ? "1" : "0");
    }
  } catch {
    /* ignore */
  }
}

export function readSupportTabPermissions() {
  try {
    const raw = localStorage.getItem("supportTabPermissions");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function readSupportHasTeam() {
  try {
    const raw = localStorage.getItem("supportHasTeam");
    if (raw === "1") return true;
    if (raw === "0") return false;
    return null;
  } catch {
    return null;
  }
}

/** Base CSR sidebar (always visible without a team). */
export const NORMAL_CSR_SIDEBAR_TABS = [
  "Dashboard",
  "Users",
  "Subscription",
  "Manual Subscription",
  "My Notifications",
  "Match User",
  "User Profiles",
];

/** Base Chat Support sidebar — same core tabs as CSR, plus team-assigned support tabs via permissions. */
export const NORMAL_CHAT_SUPPORT_SIDEBAR_TABS = [...NORMAL_CSR_SIDEBAR_TABS];

/** Team-assigned tabs relevant to Chat Support members (from team or role defaults). */
export const CHAT_SUPPORT_ASSIGNED_TAB_KEYS = [
  "tickets",
  "performance",
  "chat_support_log",
  "agent_reports",
];

/** CSR Team Lead without a team — can manage teams + base CSR tabs. */
export const NORMAL_CSR_LEAD_SIDEBAR_TABS = [
  ...NORMAL_CSR_SIDEBAR_TABS,
  "Support Teams",
  "Approvals",
];

/** Map sidebar label → support tab permission key (team-assigned tabs only). */
export const SIDEBAR_TAB_PERM_KEYS = {
  "Support Center": "tickets",
  "CSR Outreach": "csr_outreach",
  "Sale Agent": "csr_outreach",
  "CSR Leads": "csr_outreach",
  "Chat Support Log": "chat_support_log",
  "Chat / Email / Social": "chat_support_log",
  "Agent Reports": "agent_reports",
  "Support Teams": "teams",
};
